import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@store';

/**
 * Select the settings dialog state slice
 * Note: This assumes the settings dialog state will be added to the RootState
 * This will be fixed when we update the store configuration
 */
export const selectSettingsDialogState = (state: RootState) =>
  (state as unknown as { core: { settingsDialog: { isSettingsDialogOpen: boolean } } }).core.settingsDialog;

/**
 * Select whether the settings dialog is open
 */
export const selectIsSettingsDialogOpen = createSelector([selectSettingsDialogState], settingsDialogState => settingsDialogState.isSettingsDialogOpen);
